export class WsHandler {
  constructor(options) {
    this.options = options
    this.ws = null
    this.reconnectTimer = null
    this.pingTimer = null
    this.connected = false
  }

  connect() {
    var self = this
    var protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    var url = protocol + '//' + window.location.host + '/api/socket'

    // Close any existing socket before creating a new one (prevents parallel connections)
    if (this.ws) {
      try {
        this.ws.onclose = null
        this.ws.onerror = null
        this.ws.onmessage = null
        this.ws.close()
      } catch (e) { /* ignore */ }
      this.ws = null
    }

    this.ws = new WebSocket(url)

    this.ws.onopen = function() {
      self.connected = true
      self._startPing()
    }

    this.ws.onclose = function() {
      self.connected = false
      self._stopPing()
      self._scheduleReconnect()
    }

    this.ws.onerror = function() {
      self.connected = false
    }

    this.ws.onmessage = function(event) {
      try { if (window.__memTracer) window.__memTracer.tick('ws.message') } catch (_) {}
      // Boot profiler: registra duracion del handler para detectar
      // mensajes pesados durante el boot. El profiler ignora mensajes
      // post-bootDone para no acumular indefinido.
      var __bp = window.__bootProfile
      if (__bp && __bp.recordWsMessage) {
        var __t0 = performance.now()
        self._handleMessage(event.data)
        __bp.recordWsMessage(performance.now() - __t0)
      } else {
        self._handleMessage(event.data)
      }
    }
  }

  disconnect() {
    clearInterval(this.reconnectTimer)
    clearInterval(this.pingTimer)
    this.reconnectTimer = null
    this.pingTimer = null
    if (this.ws) {
      this.ws.onclose = null
      this.ws.close()
      this.ws = null
    }
    this.connected = false
  }

  _handleMessage(rawData) {
    var data
    try { data = JSON.parse(rawData) } catch(e) { return }

    var opts = this.options

    if (data.cameras && data.cameras.length) {
      var cameras = data.cameras.map(function(cam) {
        cam.groupName = (opts.groups[cam.groupId] || {}).name || ''
        return cam
      })
      opts.onEntities('camera', cameras)
    }

    if (data.devices && data.devices.length) {
      var devices = data.devices.map(function(dev) {
        dev.groupName = (opts.groups[dev.groupId] || {}).name || ''
        if (dev.category && opts.categoryData.deviceCategories) {
          dev.categoryData = opts.categoryData.deviceCategories[dev.category] || null
        }
        return dev
      })
      opts.onEntities('device', devices)
    }

    if (data.positions && data.positions.length) {
      opts.onPositions(data.positions)
    }

    if (data.buses && data.buses.length) {
      opts.onEntities('bus', data.buses)
    }

    if (data.lprs && data.lprs.length) {
      opts.onEntities('lpr', data.lprs)
    }

    if (data.incidents && data.incidents.length) {
      var incidents = data.incidents.map(function(inc) {
        if (inc.type && opts.categoryData.incidentCategories) {
          inc.categoryData = opts.categoryData.incidentCategories[inc.type] || null
        }
        return inc
      })
      // Pasan ACTIVO e HISTORICO: MapV2 decide agregar o remover segun status
      // + antigüedad (>12h se descarta como en Map.vue viejo).
      opts.onEntities('incident', incidents)
    }

    if (data.sensors && data.sensors.length) {
      var sensors = data.sensors.map(function(s) {
        s.groupName = (opts.groups[s.groupId] || {}).name || ''
        if (s.category && opts.categoryData.sensorCategories) {
          s.category = opts.categoryData.sensorCategories[s.category] || null
        }
        return s
      })
      opts.onEntities('sensor', sensors)
    }

    if (data.murphy_hits && data.murphy_hits.length) {
      // Los hits (iSentry, Acuseek, hitLpr, etc.) NO son entities persistentes
      // en el mapa — son alertas puras que alimentan el tab "Hits" del sidebar.
      // El backend los incluye en el payload inicial del WS como "murphy_hits".
      if (opts.onHits) opts.onHits(data.murphy_hits, 'murphy')
    }

    if (data.sos_incidents && data.sos_incidents.length) {
      opts.onEntities('sos_call', data.sos_incidents)
    }

    if (data.geofences && data.geofences.length) {
      opts.onGeofences(data.geofences)
    }

    if (data.geofence_remove && data.geofence_remove.length) {
      opts.onGeofenceRemove(data.geofence_remove.map(function(g) { return g.id }))
    }

    if (data.events && data.events.length) {
      opts.onEvents(data.events)
    }
  }

  _startPing() {
    var self = this
    this.pingTimer = setInterval(function() {
      if (self.ws && self.ws.readyState === WebSocket.OPEN) {
        self.ws.send('ping')
      }
    }, 30000)
  }

  _stopPing() {
    clearInterval(this.pingTimer)
    this.pingTimer = null
  }

  _scheduleReconnect() {
    if (this.reconnectTimer) return
    var self = this
    this.reconnectTimer = setInterval(function() {
      if (!self.connected) {
        self.connect()
      } else {
        clearInterval(self.reconnectTimer)
        self.reconnectTimer = null
      }
    }, 3000)
  }
}
